import { makeStyles } from '@material-ui/core/styles'
import FormikField from '../../1elements/Fields/FormikField'
import ProvinceSelect from '../Select/ProvinceSelect'
import { useSelector } from '../../../common/redux.Interface.Component'
import { reExportedColors } from '../../1elements/index'

const AddressFieldsLine = ({ cardIndex, fieldIndex }) => {
  const classes = useStyles()
  const validationErrors = useSelector(state => state.tabs.validationErrors)
  const errorRef = `values[${cardIndex}].cardData[${fieldIndex}].fieldData`
  const errorMsg = validationErrors ? validationErrors[errorRef] : null
  const name = (fieldIndex, key) => {
    return `values[${cardIndex}].cardData[${fieldIndex}].fieldData[${key}]`
  }
  let classInUse = classes.root
  if (errorMsg) {
    classInUse = classes.error
  }
  return (
    <div className={classInUse}>
      <FormikField
        name={name(fieldIndex, 'unit')}
        className={`${classes.fieldBase} ${classes.unitField}`}
        placeholder={'Unit'}
        type={'shortext'}
      />
      <FormikField
        name={name(fieldIndex, 'line_1')}
        className={`${classes.fieldBase} ${classes.lineField}`}
        placeholder={'Address'}
        type={'shortext'}
        required={true}
      />
      <FormikField
        name={name(fieldIndex, 'city')}
        className={`${classes.fieldBase} ${classes.cityField}`}
        placeholder={'City'}
        type={'shortext'}
        required={true}
      />
      <ProvinceSelect
        name={name(fieldIndex, 'state')}
        className={`${classes.fieldBase} ${classes.stateField}`}
        placeholder={'Province'}
        type={'shortext'}
        required={true}
      />
      <FormikField
        name={name(fieldIndex, 'zip_postcode')}
        className={`${classes.fieldBase} ${classes.zipField}`}
        placeholder={'Zip Code'}
        type={'shortext'}
        required={true}
      />
      <FormikField
        name={name(fieldIndex, 'country')}
        className={`${classes.fieldBase} ${classes.zipField}`}
        placeholder={'Country'}
        type={'shortext'}
        required={true}
      />
      {errorMsg && <div className={classInUse}>{errorMsg}</div>}
    </div>
  )
}

export default AddressFieldsLine

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    width: '100%',
    maxWidth: 300
  },
  error: {
    border: `1px solid ${reExportedColors.ERROR_RED}`, // HARDCODED - to be Assigned a palette color
    color: reExportedColors.ERROR_RED, // HARDCODED - to be Assigned a palette color
    display: 'flex',
    flexFlow: 'row wrap',
    width: '100%',
    maxWidth: 300
  },
  fieldBase: {
    margin: '0 5px 2px 0'
  },
  unitField: {
    width: 50
  },
  cityField: {
    width: 90
  },
  stateField: {
    width: 50
  },
  zipField: {
    width: 70
  },
  lineField: {
    width: 70
  }
})
